
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundLowFill as ObiSoundLowFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-low-fill.js';
 
 
 

 
 export const ObiSoundLowFill = createComponent({
   react: React,
   tagName: 'obi-sound-low-fill',
   elementClass: ObiSoundLowFillElement,
   events: {
     
   }
  });
 
 